import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileDropDownControlView {

    constructor() { }

    afterRender(control){
        let element = mobileAdjustment.adjustMobileControl(control);
        const height = mobileAdjustment.calculateHeight(control);
        element.find("div:first").css({"width":"100%", "height": height, "line-height": "normal", "text-align": "left", "display": "flex", "position": "relative"});
        element.find("img").css({   "right":"4px",
                                    "top":"50%", 
                                    "transform":"translateY(-50%)", 
                                    "margin-top": element[0].style.marginTop, 
                                    "margin-bottom": element[0].style.marginBottom})
    }
}

const mobileDropDownControlView = new MobileDropDownControlView();

export default mobileDropDownControlView;